// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93c35529","977":"ee4ece84"}[chunkId] + ".chunk.js";
};